/**
 * Return a media URL that is meaningful for the browser to fetch.
 *
 * Demo fixtures use RFC-reserved `.example` hosts to retain synthetic
 * provenance without pointing at real people or infrastructure. Rendering
 * those placeholders as image sources would still trigger DNS requests and
 * noisy browser errors, so treat them as absent media.
 */
export function renderableMediaUrl(url: string | null): string | null {
  // @tested-by: tst_fe_media_url_001
  // @invariant: synthetic RFC-reserved hosts never become browser requests.
  if (!url) return null;
  try {
    const hostname = new URL(url, "http://magnis.local").hostname.toLowerCase();
    if (hostname === "example" || hostname.endsWith(".example")) return null;
  } catch {
    return url;
  }
  return url;
}
